import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAzhqtSQXSKpBzG1nmZAYs1JU98BiuNWNs",
  authDomain: "mtg-deck-tool-dheizmann.firebaseapp.com",
  projectId: "mtg-deck-tool-dheizmann",
  storageBucket: "mtg-deck-tool-dheizmann.firebasestorage.app",
  messagingSenderId: "1049329536144",
  appId: "1:1049329536144:web:c4e2dbd947fe7277c49c15"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
